export const sendToGTag = (conversion) => {
  if ((window as any).gtag) {
    (window as any).gtag('event', 'conversion', {
      'send_to': `AW-540804536/${conversion}`,
    });
  }
  return false;
}